import React from 'react';
import { contact } from '../data/products';
import { translations } from '../data/translations';
import { useLanguage } from '../context/LanguageContext';

function CallToAction() {
  const { t } = useLanguage();

  return (
    <section id="contact" className="cta">
      <div className="container">
        <div className="cta-content">
          <h2 className="cta-title">{t(translations.cta.title)}</h2>
          <p className="cta-text">
            {t(translations.cta.text)}
          </p>

          <div className="cta-contacts">
            <a href={`tel:${contact.phone}`} className="contact-card contact-card-phone">
              <span className="contact-icon">{'\u{1F4DE}'}</span>
              <div className="contact-info">
                <span className="contact-label">{t(translations.cta.phoneLabel)}</span>
                <span className="contact-value contact-value-large">
                  {contact.phone}
                </span>
              </div>
            </a>

            <a href={`mailto:${contact.email}`} className="contact-card">
              <span className="contact-icon">{'\u{1F4E7}'}</span>
              <div className="contact-info">
                <span className="contact-label">{t(translations.cta.emailLabel)}</span>
                <span className="contact-value">
                  {contact.email}
                </span>
              </div>
            </a>

            <div className="contact-card">
              <span className="contact-icon">{'\u{1F4CD}'}</span>
              <div className="contact-info">
                <span className="contact-label">{t(translations.cta.addressLabel)}</span>
                <span className="contact-value">{t(contact.address)}</span>
              </div>
            </div>
          </div>

          <div className="cta-action">
            <a href={`tel:${contact.phone}`} className="btn btn-cta-primary btn-large">
              <span className="btn-icon">{'\u{1F4DE}'}</span>
              {t(translations.cta.callNow)}
            </a>
            <a href="#contact-form" className="btn btn-cta-secondary btn-large">
              {t(translations.nav.consultation)}
            </a>
          </div>

          <p className="cta-note">
            {t(translations.cta.note)}
          </p>

          <div className="cta-features">
            {translations.cta.features.map((feature, index) => (
              <div key={index} className="cta-feature">
                <span className="feature-badge">{'\u2713'}</span>
                <span>{t(feature)}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
